const qaItems = [
  {
    q: "Where is Don Collins Auto Storage located?",
    a: "Don Collins Auto Storage has two locations: Irwin St in San Rafael, CA (Marin County), and Canal Blvd in Point Richmond, CA (East Bay). The Point Richmond facility is approximately 9 miles or 15 minutes from the San Rafael location, near the Standard Oil Refinery.",
  },
  {
    q: "What vehicle storage options are available in San Rafael, CA?",
    a: "Don Collins Auto Storage in San Rafael offers fully-alarmed indoor storage for cars, motorcycles, RVs, boats, trucks, and specialty equipment on Irwin St. It&apos;s conveniently located in central Marin County, serving San Rafael, Mill Valley, Novato, and surrounding areas.",
  },
  {
    q: "Is there vehicle storage near Point Richmond or the East Bay?",
    a: "Yes. Don Collins Auto Storage operates a secure indoor facility on Canal Blvd in Point Richmond, CA, near the Standard Oil Refinery. The East Bay location serves Richmond, Berkeley, Oakland, El Cerrito, and the wider East Bay region.",
  },
  {
    q: "What areas does Don Collins Auto Storage serve?",
    a: "Don Collins serves San Rafael, Point Richmond, Marin County, the East Bay, and the greater Bay Area — including Mill Valley, San Anselmo, Fairfax, Novato, Berkeley, Oakland, Richmond, and San Francisco.",
  },
];

export default function LocationAIAnswerBlock() {
  return (
    <section
      id="about"
      className="bg-white py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="flex items-start gap-5 mb-14">
          <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full flex-shrink-0 mt-1">
            <i className="ri-robot-2-line text-charcoal text-xl"></i>
          </div>
          <div>
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-2">
              Location Overview
            </p>
            <h2 className="font-serif text-charcoal text-3xl lg:text-4xl font-bold">
              Finding Us in the Bay Area
            </h2>
          </div>
        </div>

        <div className="space-y-0">
          {qaItems.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-[#EBEBEB] py-8"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <h3
                className="font-serif text-charcoal text-xl font-semibold mb-3"
                itemProp="name"
                dangerouslySetInnerHTML={{ __html: item.q }}
              />
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p
                  className="font-sans text-[#555] text-base leading-relaxed"
                  itemProp="text"
                  dangerouslySetInnerHTML={{ __html: item.a }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-4">
          <div className="w-1 h-12 bg-gold rounded-full flex-shrink-0"></div>
          <p className="font-sans text-[#555] text-sm leading-relaxed italic">
            "Service for San Francisco, Marin County, the East Bay and beyond."
            <span className="block text-charcoal font-medium mt-1 not-italic">— Don Collins Auto Storage</span>
          </p>
        </div>
      </div>
    </section>
  );
}
